import $ from 'jquery';

function navListener() {
	var	$header 			= $('.c-header'), 
			lastScrollTop = 0;
	
	$(window).scroll(function(){
		var scrollTop = $(this).scrollTop();
		if (scrollTop > lastScrollTop){
			$header.addClass('scroll-down');
		} else {
			$header.removeClass('scroll-down');
		}

		if(scrollTop > 66) {
			$header.addClass('adjust-height');
		} else {
			$header.removeClass('adjust-height');
		}

		lastScrollTop = scrollTop;
	});
}

export { navListener };